import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Heart, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DonationSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let n = 0;
    const tick = async () => {
      if (n++ >= 30) { setStatus("timeout"); return; }
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        setTimeout(tick, 2000);
      } catch { setStatus("error"); }
    };
    tick();
  }, [sessionId]);

  return (
    <section className="container-narrow py-32 text-center" data-testid="donation-success-page">
      {status === "paid" ? (
        <>
          <Heart className="h-16 w-16 text-[hsl(var(--accent))] mx-auto" />
          <div className="overline mt-8">Donativo recebido</div>
          <h1 className="display-heading text-5xl mt-6">Obrigado.</h1>
          <span className="accent-rule mt-8 inline-block" />
          <p className="mt-8 text-lg text-[hsl(var(--muted-foreground))] leading-relaxed">
            Recebemos o seu donativo. Em breve receberá a <strong>Declaração de Donativo</strong> em PDF no seu email — para efeitos contabilísticos.
          </p>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]"><em>Que Maria abençoe a sua generosidade.</em></p>
        </>
      ) : status === "checking" ? (
        <>
          <div className="overline">A confirmar pagamento</div>
          <h1 className="display-heading text-3xl mt-4">Um momento…</h1>
        </>
      ) : (
        <>
          <CheckCircle2 className="h-12 w-12 text-[hsl(var(--primary))] mx-auto" />
          <h1 className="display-heading text-3xl mt-6">A verificar o pagamento.</h1>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">
            Se pagou por cartão ou MB WAY e o pagamento foi bem-sucedido, receberá o email de confirmação em breve.
          </p>
          <p className="mt-2 text-[hsl(var(--muted-foreground))]">
            Se escolheu <strong>referência Multibanco</strong>, a confirmação e a Declaração de Donativo chegam ao seu email assim que o pagamento da referência for processado (normalmente algumas horas após o pagamento).
          </p>
        </>
      )}
      <Link to="/" className="btn-outline mt-12 inline-flex">Voltar ao início</Link>
    </section>
  );
}
